// extracted by mini-css-extract-plugin
module.exports = {"BgImg":"HomeMainSection_BgImg__1sGhO"};